// extracted by mini-css-extract-plugin
module.exports = {"navWrapper":"NavigationItems_navWrapper__1Rfx2","navLinks":"NavigationItems_navLinks__9Rh2z"};